import * as React from "react";
import {
    PaperProps,
    Paper as MUIPaper,
    makeStyles,
    createStyles,
} from "@material-ui/core";
import { baseColors, RelodeTheme } from "..";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            paper: {borderRadius: "4px"},
            header: {
                backgroundColor: baseColors.cool_gray,
                padding: theme.spacing(1),
            },
            body: {
                padding: theme.spacing(2, 1),
            }
        }),
    { name: "Paper" }
);

interface Props extends PaperProps {
    header?: React.ReactNode;
    body?: React.ReactNode;
}

export const Paper = (props: Props) => {
    const classes = useStyles();
    const { header, body } = props;


    return (
        <MUIPaper {...props} className={classes.paper}>
            {!!header ? (
                <div className={classes.header}>
                    {header}
                </div>
            ) : null}
            {!!body ? (
                <div className={classes.body}>
                    {body}
                </div>
            ) : null}
            {props.children}
        </MUIPaper>
    );
};
